var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('top-bar'),_c('nav-bar'),_c('mobile-nav-bar'),_c('div',{staticClass:"content"},[_c('br'),_c('div',{staticClass:"container-fluid",attrs:{"id":"default-card"}},[_c('h5',{staticStyle:{"color":"#039BE5"}},[_vm._v("Welcome "+_vm._s(_vm.UserName)+" !!")]),_c('br'),_vm._t("default")],2)]),_c('default-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }